import React from 'react';
import style from './logo.module.scss';
import logoDesktopImage from 'acscp/assets/logoDesktop.png';
import { Link } from 'react-router-dom';
import { home } from 'acscp/components/routeHelper';
import { ACS_WEBSITE } from 'acscp/settings/appSettings';
import { AppState, Menu } from 'acscp/store';
import { connect } from 'react-redux';
import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';
import { userIsLoggedIn } from 'acscp/store/helpers/authHelper';

interface LogoStateProps {
    isLoggedIn: boolean;
    isNonJetPortalUser: boolean;
    mainSiteLink?: string;
}

const LogoContents: React.FC = () => (
    <>
        <div className={style.ImageMobile} />
        <img className={style.ImageDesktop} src={logoDesktopImage} />
    </>
);

export class LogoPresentational extends PresentationComponentBase<{}, LogoStateProps, {}, {}> {
    render(): JSX.Element {
        if (!this.props.isLoggedIn && this.props.isNonJetPortalUser) {
            return (
                <a
                    href={this.props.mainSiteLink || ACS_WEBSITE}
                    target={'_blank'}
                    className={style.Logo}
                >
                    <LogoContents />
                </a>
            );
        }

        return (
            <Link to={home()} className={style.Logo}>
                <LogoContents />
            </Link>
        );
    }
}

function mapStateToProps(state: AppState): LogoStateProps {
    return {
        isLoggedIn: userIsLoggedIn(state.auth),
        isNonJetPortalUser: state.auth.isNonJetPortalUser,
        mainSiteLink: state.customerContact.mainSiteLink,
    };
}

export const Logo = connect(mapStateToProps)(LogoPresentational);
